<style scoped lang="scss" src="./Register.scss"></style>
<template>
  <main class="register-container">
    <section v-show="!showFormComplete" class="register-container__content"  @keydown="handleEnterKey">
      <h1 class="title">Cadastrar</h1>
      <h1 class="title"><span class="two">Nova Conta</span></h1>
      <form class="register-container__content__form">
        <InputText isRequired
            label="CPF"
            placeholder="999.999.999-99"
            mask="###.###.###-##"
            v-model="form.cpf"
        />
        <InputText isRequired label="Nome completo" placeholder="Digite aqui" v-model="form.name"/>
        <InputText isRequired label="E-mail" placeholder="Digite aqui" v-model="form.email"/>
        <InputText isRequired label="Telefone"  mask="(##) #####-####" placeholder="Digite aqui" v-model="form.phone"/>
        <InputPassword isRequired label="Senha" placeholder="Digite aqui" v-model="form.psw"/>
        <InputPassword isRequired class="confirm-password" label="Repita a nova senha" placeholder="Digite aqui" v-model="form.pswRepeat"/>
        <section class="password-description">
          <span class="label">A senha deve possuir:</span>
          <div class="fields">
            <section class="item">
              <span class="ball" :class="{ on: checkPsw.caracter }"/>
              <span class="text">8 caracteres.</span>
            </section>
            <section class="item">
              <span class="ball" :class="{ on: checkPsw.min }"/>
              <span class="text">1 letra minúscula.</span>
            </section>
            <section class="item">
              <span class="ball" :class="{ on: checkPsw.special }"/>
              <span class="text">1 caracter especial.</span>
            </section>
            <section class="item">
              <span class="ball" :class="{ on: checkPsw.num }"/>
              <span class="text">1 número.</span>
            </section>
            <section class="item">
              <span class="ball" :class="{ on: checkPsw.max }"/>
              <span class="text">1 letra maiúscula.</span>
            </section>
          </div>
        </section>
        <footer class="act">
          <label class="msgErro">{{ msgErro }}</label>
          <button type="button" class="btn" @click="onClickRegister">Cadastrar</button>
          <button type="button" class="back" @click="gotoChangeToLogin">
            <i class="fas fa-chevron-circle-left"></i>
            <span>Voltar</span>
          </button>
        </footer>
      </form>
    </section>
    <section class="register-container__content" v-show="showFormComplete">
      <h1 class="title">Conta criada</h1>
      <h1 class="title">com <span class="two">sucesso!</span></h1>

      <span class="title-two">
        Sua conta já está pronta para realizar as teleconsultas. Para acessar
        o sistema volte para a tela inicial e realize o login.
      </span>
      <span class="title-two">
        Caso algum problema ocorra, entre em contato conosco pelo suporte.
      </span>

      <footer class="act">
        <button class="btn" @click="gotoChangeToLogin">Concluir</button>
      </footer>
    </section>
    <aside v-show="showFormComplete">
      <Carousel/>
    </aside>
  </main>

</template>


<script>
import InputPassword from "@/components/input/password/InputPassword.vue";
import InputText from "@/components/input/text/InputText.vue";
import ApiService from "@/views/patient/main/services/ApiService";
import Carousel from "@/views/patient/main/components/Carousel.vue";

export default {
  name: "Register",
  components: {Carousel, InputText, InputPassword},

  data() {
    return {
      msgErro: null,
      inputCpf: null,
      inputPsw: null,
      form: {
        cpf: null,
        name: null,
        psw: null,
        pswRepeat: null,
        email: null,
        phone: null,
      },
      checkPsw: {
        caracter: false,
        min: false,
        special: false,
        num: false,
        max: false,
      },
      completeRegister: false,
      ApiService: null,
      runningRegisterUser: false
    };
  },
  watch: {
    "form.psw"(val) {
      this.validateCheckPassword(val);
    },
  },
  computed: {
    showFormComplete() {
      return this.completeRegister
    },
  },

  async mounted() {
    this.ApiService = new ApiService();
  },

  methods: {

    gotoChangeToLogin() {
      this.$router.push({path: "/"});
    },

    /**
     * Alterna a exibição da interface para o formulário de conclusão.
     */
    gotoFormComplete() {
      console.log('caiu aqui');
      this.completeRegister = true;
    },

    /**
     * Executa a ação após o registro e retorna ao formulário de login.
     */
    onClickRegister() {
      if (this.runningRegisterUser) {
        return
      }
      console.log('to aqui')
      this.runningRegisterUser = true
      this.msgErro = null;
      setTimeout(async () => {
        if (!this.validateCpf()) {
          this.msgErro = `CPF incorreto.`;
          this.runningRegisterUser = false
          return;
        }
        if (!this.validateEmail()) {
          this.msgErro = `E-mail inválido.`;
          this.runningRegisterUser = false
          return;
        }
        if (!this.validateName()) {
          this.msgErro = `O nome e sobrenome devem conter pelo menos 3 letras cada.`;
          this.runningRegisterUser = false
          return;
        }
        if (!this.validateFormPassword()) {
          this.msgErro = `Senha inválida.`;
          this.runningRegisterUser = false
          return;
        }
        if (!this.validateRepeatPassword()) {
          this.msgErro = `As senhas não coincidem. Por favor, verifique.`;
          this.runningRegisterUser = false
          return;
        }
        if (!this.form.phone) {
          this.msgErro = `Não foi informado nenhum telefone.`;
          this.runningRegisterUser = false
          return;
        }
        const payload = this.form;
        const responseSave = await this.ApiService.createUser(payload);
        if (responseSave.status) {
          this.gotoFormComplete();
          this.runningRegisterUser = false
        } else {
          this.msgErro = responseSave.msg;
          this.runningRegisterUser = false
        }
      }, 100);
    },

    /**
     * Valida o nome fornecido, verificando se o nome e o
     * sobrenome possuem pelo menos 3 letras cada.
     * @returns {boolean} Retorna true se o nome e
     * sobrenome forem válidos, caso contrário, false.
     */
    validateName() {
      if (!this.form.name) {
        return false;
      }
      const fullName = this.form.name.trim().split(" ");
      if (fullName.length < 2) {
        return false; // Verifica se há ao menos um nome e um sobrenome
      }

      const firstName = fullName[0];
      const lastName = fullName.slice(1).join(" "); // Junta o restante para garantir sobrenomes compostos

      return firstName.length >= 3 && lastName.length >= 3;
    },

    /**
     * Valida se a senha repetida é igual à senha original.
     * @returns {boolean} Retorna true se as duas
     * senhas forem iguais, caso contrário, false.
     */
    validateRepeatPassword() {
      return this.form.psw === this.form.pswRepeat;
    },

    /**
     * Valida o CPF fornecido, verificando se segue o formato correto e se é válido.
     * @returns {boolean} Retorna true se o CPF for válido, caso contrário, false.
     */
    validateCpf() {
      const inputCpf = this.inputCpf || this.form.cpf;
      if (!inputCpf) {
        return false;
      }
      const cpf = inputCpf.replace(/[^\d]/g, ""); // Remove caracteres não numéricos
      if (cpf.length !== 11) {
        return false;
      }

      // Validação dos dígitos verificadores do CPF
      let sum = 0;
      let remainder;

      // Verifica se o CPF é uma sequência de números iguais (inválido)
      if (/^(\d)\1*$/.test(cpf)) {
        return false;
      }

      // Cálculo do primeiro dígito verificador
      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }
      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      // Cálculo do segundo dígito verificador
      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }
      return remainder === parseInt(cpf.substring(10, 11));
    },

    /**
     * Valida a senha fornecida, verificando se ela possui:
     * - Pelo menos 8 caracteres;
     * - Pelo menos 1 número;
     * - Pelo menos 1 letra maiúscula;
     * - Pelo menos 1 letra minúscula;
     * - Pelo menos 1 caractere especial.
     * @returns {boolean} Retorna true se a senha for válida, caso contrário, false.
     */
    validateFormPassword() {
      if (!this.form.psw) {
        return false;
      }
      // Regex para validar a senha
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      return passwordRegex.test(this.form.psw);
    },

    /**
     * Verifica se um endereço de email é válido.
     * @returns {boolean} Retorna `true` se o email for válido, caso contrário `false`.
     */
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.form.email);
    },

    /**
     * Verifica se uma senha atende aos critérios de segurança.
     * @param {string} password - A senha a ser verificada.
     */
    validateCheckPassword(password) {
      if (!password) {
        this.checkPsw = {
          caracter: false,
          min: false,
          special: false,
          num: false,
          max: false,
        };
        return;
      }
      this.checkPsw = {
        caracter: password.length >= 8,
        min: /[a-z]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        num: /\d/.test(password),
        max: /[A-Z]/.test(password),
      };
    },
    /**
     * Detecta a tecla "Enter" e chama o método `actOpenRoom` se pressionada.
     * @param {KeyboardEvent} event - O evento de teclado que foi disparado.
     */
    handleEnterKey(event) {
      if (event.key === "Enter") {
        this.onClickRegister()
      }
    },
  }
}

</script>
